import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSKeyloopConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type KeyloopConfig = Pick<DealerDMSKeyloopConfig, "contract_code" | "api_key" | "api_password">;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const KeyloopConfigSection = () => {
  const { t } = useTranslation();

  const { watch } = FormHelper.useFormContext();
  const keyloopConfig = watch("keyloop_config");

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field required error={!keyloopConfig?.contract_code}>
          <label>{t("v8_contract_code", "Contract code")} </label>
          <FormHelper.Field.Input name="keyloop_config.contract_code" preventAutofill inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_api_key", "API key")} </label>
          <FormHelper.Field.Input name="keyloop_config.api_key" preventAutofill inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_api_password", "API password")} </label>
          <FormHelper.Field.Input name="keyloop_config.api_password" preventAutofill inputProps={{ fluid: true, type: "password" }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
